// extracted by mini-css-extract-plugin
module.exports = {"container":"preview_container__3tyz3","comicLabel":"preview_comicLabel__2qlCh","thumbnail":"preview_thumbnail__PGGfu","throbber":"preview_throbber__3alol"};